<schedule-base-item
  [scheduleItem]="schedule()"
  [shift]="shift()"
  [team]="team()"
  [isDisabled]="isDisabled()"
  [isLocked]="isLocked()"
  [draggable]="{ type: DragType.SCHEDULE, shift: schedule() }"
  [color]="shift()?.color"
  [isConflicted]="isConflicted()"
  [canFindCover]="canFindCover()"
  (findCover)="openFindCover($event)"
  (onDelete)="deleteSchedule()"
  [disableHoverButtons]="disableHoverButtons()"
  [mode]="mode()"
>
  <ng-template scheduleItemTooltip>
    <schedule-item-tooltip
      [schedule]="schedule()"
      [shift]="shift()"
      [mode]="mode()"
      [isDisabled]="isDisabled()"
      [conflicts]="conflicts()"
      [violation]="violation()"
      [scheduledDepartment]="scheduledDepartment()"
      [scheduledTeam]="scheduledTeam()"
    />
  </ng-template>

  <div schedule-item-content class="ml-3 flex h-full w-[calc(100%-10px)] justify-between pr-2">
    <div
      class="flex h-full flex-col justify-center truncate"
      [ngClass]="{
        italic: isDisabled(),
        'text-default': !isDisabled(),
        'text-subtle': isDisabled(),
      }"
    >
      @if (mode() === 'team') {
        <span class="overflow-hidden text-sm font-bold text-ellipsis"
          >{{ shift()?.name }} | {{ schedule().starttime | time }}
          @if (!schedule().hide_end_time) {
            - {{ schedule().endtime | time }}
          }
        </span>
        <span
          class="text-xs text-ellipsis overflow-hidden {{ isDisabled() ? 'text-subtle' : 'text-support' }}"
          data-hj-suppress
          >{{ schedule().employeeName }}</span
        >
      } @else {
        @if (periodType() === 'month') {
          <span class="overflow-hidden text-sm font-bold text-ellipsis">
            {{ shift()?.name ?? ('External' | translate) }}
          </span>
        } @else {
          <span class="overflow-hidden text-sm font-bold text-ellipsis">
            {{ shift()?.long_name ?? ('External' | translate) }}
          </span>
        }
        <span class="text-xs text-ellipsis overflow-hidden {{ isDisabled() ? 'text-subtle' : 'text-support' }}"
          >{{ schedule().starttime | time }}
          @if (!schedule().hide_end_time) {
            - {{ schedule().endtime | time }}
          }
        </span>
      }
    </div>

    <div
      class="sh-tl__static--icons hidden items-center gap-1 lg:flex"
      [class.text-default]="!isDisabled()"
      [class.text-subtle]="isDisabled()"
    >
      @if (schedule().loading) {
        <sb-spinner [size]="'sm'" [strokeColor]="'current'" />
      } @else {
        @if (shift()?.is_task) {
          <sb-icon [name]="'task-2-regular'" [size]="'lg'" />
        }
        @if (isConflicted()) {
          <sb-icon class="text-danger" [name]="'warning-filled'" [size]="'lg'" />
        }
        @if ((planType.BASIC | planCheck) && schedule()['Exchange']) {
          <sb-icon [name]="'transfer-3-regular'" [size]="'lg'" />
        }
        @if (schedule().recurring && !schedule()['Exchange']) {
          <sb-icon [name]="'repeat-regular'" [size]="'lg'" />
        }
        @if (isLocked() && !isProposed()) {
          <span role="img" [attr.aria-label]="'Locked' | translate" class="inline-flex">
            <sb-icon name="lock-regular" size="lg" />
          </span>
        }
      }
    </div>
  </div>
</schedule-base-item>
